var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0013 1.82978C5.04112 1.82978 1.83076 5.04014 1.83076 9.00033C1.83076 12.9605 5.04112 16.1709 9.0013 16.1709C12.9615 16.1709 16.1718 12.9605 16.1718 9.00033C16.1718 5.04014 12.9615 1.82978 9.0013 1.82978ZM0.667969 9.00033C0.667969 4.39795 4.39893 0.666992 9.0013 0.666992C13.6037 0.666992 17.3346 4.39795 17.3346 9.00033C17.3346 13.6027 13.6037 17.3337 9.0013 17.3337C4.39893 17.3337 0.667969 13.6027 0.667969 9.00033ZM8.41991 5.12436C8.41991 4.80326 8.68021 4.54296 9.0013 4.54296H9.00906C9.33015 4.54296 9.59045 4.80326 9.59045 5.12436C9.59045 5.44545 9.33015 5.70575 9.00906 5.70575H9.0013C8.68021 5.70575 8.41991 5.44545 8.41991 5.12436ZM7.45092 7.64374C7.12982 7.64374 6.86952 7.90404 6.86952 8.22513C6.86952 8.54623 7.12982 8.80653 7.45092 8.80653H8.41991V11.5197H7.45092C7.12982 11.5197 6.86952 11.78 6.86952 12.1011C6.86952 12.4222 7.12982 12.6825 7.45092 12.6825H9.0013H10.5517C10.8728 12.6825 11.1331 12.4222 11.1331 12.1011C11.1331 11.78 10.8728 11.5197 10.5517 11.5197H9.5827V8.22513C9.5827 7.90404 9.3224 7.64374 9.0013 7.64374H7.45092Z",
    fill: "#9B9DAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.231001efe9f65afa6700e7dcd4643e34.svg";
export { ForwardRef as ReactComponent };